import { buildModelManager } from "../builder.js";
const DefaultPaymentMilestoneSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  deletedAt: true,
  fixedAmount: true,
  invoiceId: true,
  label: true,
  percentage: true,
  profileId: true,
  requiredToStart: true,
  status: true,
  triggerStageSlug: true,
  type: true,
  updatedAt: true,
  workItemId: true
};
const modelApiIdentifier = "paymentMilestone";
const pluralModelApiIdentifier = "paymentMilestones";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPaymentMilestoneSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPaymentMilestoneSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPaymentMilestoneSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPaymentMilestoneSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPaymentMilestoneSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPaymentMilestoneSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPaymentMilestoneSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createPaymentMilestone",
    operationReturnType: "CreatePaymentMilestone",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      paymentMilestone: { required: false, type: "CreatePaymentMilestoneInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPaymentMilestoneSelection
  },
  {
    type: "action",
    operationName: "bulkCreatePaymentMilestones",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreatePaymentMilestonesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPaymentMilestoneSelection
  },
  {
    type: "action",
    operationName: "updatePaymentMilestone",
    operationReturnType: "UpdatePaymentMilestone",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      paymentMilestone: { required: false, type: "UpdatePaymentMilestoneInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPaymentMilestoneSelection
  },
  {
    type: "action",
    operationName: "bulkUpdatePaymentMilestones",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdatePaymentMilestonesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPaymentMilestoneSelection
  },
  {
    type: "action",
    operationName: "deletePaymentMilestone",
    operationReturnType: "DeletePaymentMilestone",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeletePaymentMilestones",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "restorePaymentMilestone",
    operationReturnType: "RestorePaymentMilestone",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      paymentMilestone: { required: false, type: "RestorePaymentMilestoneInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPaymentMilestoneSelection
  },
  {
    type: "action",
    operationName: "bulkRestorePaymentMilestones",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkRestorePaymentMilestonesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPaymentMilestoneSelection
  },
  {
    type: "action",
    operationName: "upsertPaymentMilestone",
    operationReturnType: "UpsertPaymentMilestone",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      paymentMilestone: { required: false, type: "UpsertPaymentMilestoneInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreatePaymentMilestoneResult": { hasReturnType: false },
      "... on UpdatePaymentMilestoneResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPaymentMilestoneSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertPaymentMilestones",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertPaymentMilestonesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultPaymentMilestoneSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "paymentMilestoneGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const PaymentMilestoneManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultPaymentMilestoneSelection,
  operations
);
export {
  DefaultPaymentMilestoneSelection,
  PaymentMilestoneManager
};
//# sourceMappingURL=PaymentMilestone.js.map
